import { jsx, jsxs } from 'react/jsx-runtime';
import { createContext, useContext, useMemo } from 'react';
import { useComponentFrameworkState } from '@provider/component-framework';
import { IsomorphicPortal } from '@utils/react';
import { createNotifierStore } from './notifier.store.js';

const StoreContext = createContext({});
const UIContext = createContext({});
function makeNotifierProvider(args) {
  const store = createNotifierStore(args.name);
  return function NotifierProvider(props) {
    const AncestorComponets = useContext(UIContext);
    const Components = useMemo(
      () => ({ ...AncestorComponets, ...args.ui }),
      [AncestorComponets]
    );
    const targetSelector = useComponentFrameworkState(
      (state) => state.overlayContainerSelector
    );
    const compomentFramreworkTarget = targetSelector && document.querySelector(targetSelector) || void 0;
    const dialogs = (() => {
      var _a;
      if (!Components.Dialogs) {
        return null;
      }
      const targetOrRef = ((_a = props.containers) == null ? void 0 : _a.dialogs) || compomentFramreworkTarget;
      if (targetOrRef === "inline") {
        return /* @__PURE__ */ jsx(Components.Dialogs, {});
      }
      const target = targetOrRef && "current" in targetOrRef ? targetOrRef.current : targetOrRef;
      return /* @__PURE__ */ jsx(IsomorphicPortal, { target, children: /* @__PURE__ */ jsx(Components.Dialogs, {}) });
    })();
    const modals = (() => {
      var _a;
      if (!Components.Modals) {
        return null;
      }
      const targetOrRef = ((_a = props.containers) == null ? void 0 : _a.modals) || compomentFramreworkTarget;
      if (targetOrRef === "inline") {
        return /* @__PURE__ */ jsx(Components.Modals, {});
      }
      const target = targetOrRef && "current" in targetOrRef ? targetOrRef.current : targetOrRef;
      return /* @__PURE__ */ jsx(IsomorphicPortal, { target, children: /* @__PURE__ */ jsx(Components.Modals, {}) });
    })();
    const toasts = (() => {
      var _a;
      if (!Components.Toasts) {
        return null;
      }
      const targetOrRef = ((_a = props.containers) == null ? void 0 : _a.toasts) || compomentFramreworkTarget;
      if (targetOrRef === "inline") {
        return /* @__PURE__ */ jsx(Components.Toasts, {});
      }
      const target = targetOrRef && "current" in targetOrRef ? targetOrRef.current : targetOrRef;
      return /* @__PURE__ */ jsx(IsomorphicPortal, { target, children: /* @__PURE__ */ jsx(Components.Toasts, {}) });
    })();
    return /* @__PURE__ */ jsx(UIContext.Provider, { value: Components, children: /* @__PURE__ */ jsxs(StoreContext.Provider, { value: store, children: [
      props.children,
      dialogs,
      modals,
      toasts
    ] }) });
  };
}

export { StoreContext, makeNotifierProvider };
//# sourceMappingURL=notifier.provider.js.map
